var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('small',{staticClass:"text-muted"},[_c('sup',[_vm._v("*")]),_vm._v("Veuillez utiliser le clavier numérique pour la saisie des prix. Les virgules ne sont pas prise en charge. ")])
}]

export { render, staticRenderFns }